import { AppLinks, AppSize, pxToRem } from "@/util";
import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import Image from "next/image";
import { AppColors } from "@/assets/colors";

import { FeaturedCarousel } from "./featuredCarousel";

export default function Discover() {
  const { classes } = styles();
  return (
    <Box className={classes.container}>
      <Box className={classes.carousel}>
        <FeaturedCarousel isPagination={false}>
          <Image
            src="/images/home/home image.svg"
            alt="discover"
            objectFit="cover"
            fill={true}
          />
          <Image
            src="/images/home/carouselimage2.svg"
            alt="discover"
            objectFit="cover"
            fill={true}
          />
          <Image
            src="/images/home/carouselimage3.svg"
            alt="discover"
            objectFit="cover"
            fill={true}
          />
          <Image
            src="/images/home/carouselimage4.svg"
            alt="discover"
            objectFit="cover"
            fill={true}
          />
          {/*  */}
        </FeaturedCarousel>
      </Box>
      <Box className={classes.sub}>
        <Box className={classes.subCont}>
          <Box className={classes.disCont}>
            <Typography className={classes.dvdTxt}>
              Discover Your Dream{" "}
            </Typography>
            <Box sx={{ display: "flex", gap: 2 }} className={classes.alignment}>
              <Typography className={`${classes.dvdTxt}`}>
                Property with <span className={classes.dvdTxt2}>AREL</span>
              </Typography>
            </Box>
          </Box>
          <Box className={classes.descCont}>
            <Typography className={classes.descTxt}>
              Looking for your dream home or a profitable investment? Arel
              offers premium real estate solutions.
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 2 }} className={classes.buttonsCont}>
            <Button
              href={AppLinks.PUBLIC.LISTINGS}
              variant="outlined"
              className={classes.investBtn}
            >
              <Typography color="textPrimary" className={classes.investTxt}>
                Invest Now
              </Typography>
            </Button>
            <Button
              href={AppLinks.PUBLIC.CONSULTATION}
              className={classes.consultBtn}
            >
              <Typography className={classes.consultTxt}>
                Book Consultation
              </Typography>
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    height: pxToRem(700),
    position: "relative",
  },
  buttonsCont: {
    [theme.breakpoints.down("sm")]: {},
  },
  carousel: {
    position: "absolute",
    width: "100%",
    height: "100%",
  },
  sub: {
    position: "relative",
    zIndex: 5,
    width: "100%",
    height: "100%",
    padding: `0px ${pxToRem(AppSize.padding)}`,
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      padding: `0px 30px`,
    },
  },
  subCont: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {},
  },
  dvdTxt: {
    fontFamily: "Playfair Display",
    fontWeight: 700,
    fontSize: pxToRem(60),
    color: AppColors.neutral["110"],
    [theme.breakpoints.down(1360)]: {
      fontSize: pxToRem(55),
    },
    [theme.breakpoints.down(698)]: {
      fontSize: pxToRem(45),
    },
    [theme.breakpoints.down(601)]: {
      fontSize: pxToRem(40),
    },
    [theme.breakpoints.down(552)]: {
      fontSize: pxToRem(35),
    },
    [theme.breakpoints.down(321)]: {
      fontSize: pxToRem(29),
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(34),
      width: "106%",
    },
  },
  descTxt: {
    color: AppColors.neutral["110"],
    fontWeight: 400,
    fontSize: pxToRem(20),
    fontFamily: "General sans",
  },
  descCont: {
    width: "70%",

    [theme.breakpoints.down(698)]: {
      width: "90%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.down(543)]: {
      textAlign: "left",
    },
  },
  dvdTxt2: {
    color: AppColors.primary["200"],
  },
  investTxt: {
    fontWeight: 500,
    fontSize: pxToRem(16),
  },
  investBtn: {
    border: `1px solid ${AppColors.neutral["70"]}`,
    height: pxToRem(46),
    borderRadius: pxToRem(8),
    width: pxToRem(143),
    backgroundColor: theme.colors.white,
    [theme.breakpoints.down("sm")]: {
      width: "45%",
    },
  },
  consultBtn: {
    background: AppColors.gradient.secondary,
    padding: theme.spacing(3),
    borderRadius: pxToRem(8),
    height: pxToRem(46),
    [theme.breakpoints.down("sm")]: {},
  },
  consultTxt: {
    fontWeight: 500,
    fontSize: pxToRem(16),
    color: theme.colors.white,
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(15),
    },
  },
  // Additional fixes
  alignment: {
    marginTop: pxToRem(-25),
    width: "102%",
  },
  disCont: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
  },
}));
